import { angularEvents } from "../../bridge/angularEvents";

// @ngInject
function stateConfig($stateProvider) {
    $stateProvider.state('main', {
        parent: 'app',
        abstract: true,
        url: '',
        views: {
            "app-content": {
                templateUrl: 'main/main.tpl.html',
                controller: 'MainController as vm'
            }
        },
        data: { claims: ['user']}
    });
}
// @ngInject
function MainController($rootScope, $state, $location, currentUser, AuthService, userPrintQRCodeDialogService, UserTimeStampingDialogService, TimeStampingApiService, $window, NavigationApiService, VersionService, TimedOutLoginDialogService, ToasterService) {
    var vm = this;

    $rootScope.currentUser = currentUser;

    vm.currentUserClaims = currentUser.claims;
    vm.currentLicense = currentUser.licenseConfig;
    vm.menuNodes = [];
    vm.latestTimeStamp = {};
    vm.loginDialog = false;
    vm.tenant = currentUser.tenant;

    vm.currentUser = currentUser;

    vm.logOut = AuthService.logOut;
    vm.openTimeStampingModal = openTimeStampingModal;
    vm.hasVersionChanged = VersionService.hasVersionChanged;
    vm.isReloading = false;
    vm.reload = reload;
    vm.currentTenantLogoPath = "";
    vm.supportViewOptionEnabled = cleverAppsLoggedIn();
    vm.openPrintQRCodeModal = openPrintQRCodeModal;

    activate();

    function activate() {
       NavigationApiService.getNavigationNodes().then(function(nodes) {vm.menuNodes = nodes;});

        updateLatestTimeStamp();
      $(document).on('click', '[ui-toggle]', function (e) {
          e.preventDefault();
          var eventTarget = $(e.target);
          var result = eventTarget.attr('ui-toggle') || (eventTarget = eventTarget.closest('[ui-toggle]'));
          var $target = $(eventTarget.attr('target')) || eventTarget;
          $target.toggleClass(eventTarget.attr('ui-toggle'));
      });
        console.log($rootScope.currentUser.tenant.tenantStringIdentifier.toLowerCase());
        $rootScope.$on('Version.Changed', function() {
            vm.hasVersionChanged = true;
        });

        var tenantStringIdentifier = $rootScope.currentUser.tenant.tenantStringIdentifier.toLowerCase();

        if(isZalando(tenantStringIdentifier)) tenantStringIdentifier = "zalando";

        if(isFutureOfRetail(tenantStringIdentifier)) tenantStringIdentifier = "for";

        if(isYabie(tenantStringIdentifier)) tenantStringIdentifier = "yabie";

        angularEvents.userIsAuthenticated.dispatch();

        vm.currentTenantLogoPath = "./assets/images/" + tenantStringIdentifier + "_logo.png";
        VersionService.start();

        queueRefreshSession();


        //var t=setInterval(checkToken, 20000);
    }

    function openPrintQRCodeModal(){
        userPrintQRCodeDialogService.showDialog(vm.currentUser).then(function(response){
            if(response)
                console.log("OK!");
        });
    }

    function cleverAppsLoggedIn() {
        return $rootScope.currentUser.firstName === "CleverApps" &&
            ($rootScope.currentUser.lastName === "Superuser" ||
                $rootScope.currentUser.lastName === "Support" ||
                $rootScope.currentUser.lastName === "Thomas Sverker") &&
            ($rootScope.currentUser.username === "superuser" ||
                $rootScope.currentUser.username === "support" ||
                $rootScope.currentUser.username === "thsv");
    }

    // For our Zalando Customers
    function isZalando(tenantStringIdentifier) {
        var currentUrl = $location.$$absUrl.toLowerCase();
        return currentUrl.includes("zalando");
        //return (tenantStringIdentifier === "streetone" ||
        //        tenantStringIdentifier === "amazing" ||
        //        tenantStringIdentifier === "urbanmodern" ||
        //        tenantStringIdentifier === "casualwoman")
    }

    // For our FutureOfRetail Customers
    function isFutureOfRetail(tenantStringIdentifier) {
        var currentUrl = $location.$$absUrl.toLowerCase();
        return currentUrl.includes("for");
        //return (tenantStringIdentifier === "nordicoutlet")
    }

    // For our Yabie customers
    function isYabie(tenantStringIdentifier) {
        var currentUrl = $location.$$absUrl.toLowerCase();
        return currentUrl.includes("yabie");
    }

    function reload() {
        vm.isReloading = true;
        VersionService.reload();
    }

    function openTimeStampingModal() {
        UserTimeStampingDialogService.showDialog().finally(function() {
            updateLatestTimeStamp();
        });
    }

    function updateLatestTimeStamp() {
        TimeStampingApiService.getLatestTimeStamps(1).then(function(response) {
            if (response.data.length !== 0) {
                vm.latestTimeStamp = response.data[0];
            }
        }, function(error) {
            console.log(error);
        });
    }

    function queueRefreshSession() {
        if (vm.loginDialog) return;

        AuthService.getTokenExpired().then(function(response) {
            var expireDate = response.data.expireDate;

            if(expireDate !== null) {
                var timeUntilExpire = Date.parse(expireDate)-Date.parse(new Date());

                if(timeUntilExpire <= 0){
                    console.log('Token has expired!');
                    vm.logOut();
                    $state.reload();
                }

                console.log('Token will expire in: ' + timeUntilExpire);
                // Displays Dialog 30 minutes before token expires
                var timeUntilShowDialog = timeUntilExpire-(1000 * 60 * 30); //30 minutes
                setTimeout(function() {
                    showRefreshSessionDialog(expireDate);
                }, timeUntilShowDialog);
            }
        });
    }

    function showRefreshSessionDialog(tokenExpireDate) {
        vm.loginDialog = true;
        TimedOutLoginDialogService.showDialog(vm.currentUser.username, tokenExpireDate).then(function(sessionRefreshed) {
            if(sessionRefreshed) {
                vm.loginDialog = false;
                queueRefreshSession();
            }
            else {
                vm.logOut();
                $state.reload();
            }
        }, function(error) {
            ToasterService.showError(error.data.message);
        }).finally(function() {
        });
    }
}

angular
    .module('app.main', [
        'main.base',
        'main.contacts',
        'main.product',
        'main.order',
        'main.customerorder',
        'main.resellerorder',
        'main.customerinvoice',
        'main.stock',
        'main.analysis',
        'main.stocklogistics',
        'main.budget',
        'main.timestamp',
        'main.economy',
        'main.sales',
        'main.support',
        'timedOutLoginDialog.timedOutLoginDialog',
        'main.discountManagement'
    ])
    .config(stateConfig)
    .controller('MainController', MainController);
